module.exports = __webpack_public_path__ + "static/colors-content-contrast-dc00e53434b56410754eee55de012826.png";